<template>
  <article class="article">
    <nuxt-link :to="`/blogg/${slug}`" class="full-width">
      <div class="image">
        <NuxtImg
            loading="lazy"
            :src="image"
            :alt="title" :title="title"/>
      </div>
      <div class="bottom">
        <div class="date"><span>{{ date }}</span></div>
        <Heading tag="h2" class="title">{{ title }}</Heading>
        <div class="description">{{ description }} <span class="show-article">Mer →</span></div>
        <hr>
      </div>
    </nuxt-link>
  </article>
</template>

<script>
import Heading from "~/components/atoms/Heading.vue";

export default {
  components: {Heading},
  props: {
    title: {
      type: String,
      required: true
    },
    slug: {
      type: String,
      required: true
    },
    image: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: true
    },
    date: {
      type: String,
      required: true
    }
  }
}
</script>

<style scoped lang="scss">
.article {
  box-shadow: 0 3px 6px rgba(0, 0, 0, .16);
  background-color: #fff;
  height: 482px;

  .image {
    width: 100%;
    height: 262px;
    overflow: hidden;

    img {
      width: 100%;
    }
  }

  .bottom {
    padding: 15px 27px;

    .date {
      height: 16px;
      color: $light-black;
      font-size: 11px;
      font-weight: 400;
    }

    .title {
      width: 100%;
      height: 51px;
      color: #282828;
      font-size: 18px;
      font-weight: 600;
      margin-top: 12px;
    }

    .description {
      font-size: 12px;
      font-weight: 400;
      margin-bottom: 26px;
      text-align: left;
      color: $black;
      margin-top: 6px;
      display: block;
    }

    .show-article {
      color: $yellow;
      margin-left: 10px;
    }
  }
}
</style>
